import { ErrorHandler } from './errorHandler';
import { Service, Inject } from 'vue-di-container';
import http, { NajizHttpProxy, NajizHttpResponse } from '@moj/najiz-http';
import LoaderService from './loaderService';

@Service()
export default class HttpService {
    @Inject(LoaderService) loaderService!:LoaderService;
    public httpInstance: NajizHttpProxy;
    public httpInstanceWithoutLoader: any;
    public httpInstanceWithOnlyDomainBaseUrl: any;

    constructor() {
      const config = {
        baseURL: process.env.BASE_URL,
      };

      this.httpInstance = http.create(config);
      this.httpInstanceWithoutLoader = http.create(config);
      this.httpInstanceWithOnlyDomainBaseUrl = http.create({
        ...config,
        baseURL: location.origin,
      });

      this.httpInstance.interceptors.request.use(
        (request) => {
          if (request.data?.noGlobalLoader) {
            return request;
          }
          this.loaderService.showLoader();
          return request;
        },
        (error:Error) => ErrorHandler.errorResponseHandler(error),
      );

      this.httpInstanceWithoutLoader.interceptors.request.use(
        (request:any) => request,
        (error:Error) => ErrorHandler.errorResponseHandler(error),
      );

      this.httpInstanceWithOnlyDomainBaseUrl.interceptors.request.use(
        (request:any) => request,
        (error:Error) => ErrorHandler.errorResponseHandler(error),
      );

      // Add a response interceptor
      this.httpInstance.interceptors.response.use(
        (response:NajizHttpResponse) => {
          this.loaderService.hideLoader();
          return response;
        },
        (error:Error) => {
          ErrorHandler.errorResponseHandler(error);
        },
      );

      this.httpInstanceWithoutLoader.interceptors.response.use(
        (response:NajizHttpResponse) => response,
        (error:Error) => {
          ErrorHandler.errorResponseHandler(error);
        },
      );

      this.httpInstanceWithOnlyDomainBaseUrl.interceptors.response.use(
        (response:NajizHttpResponse) => response,
        (error:Error) => {
          ErrorHandler.errorResponseHandler(error);
        },
      );
    }
}
